import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { deliveryItems } from '../data/content';
export function Delivery() {
  return <section className="w-full bg-cream px-5 pb-24 sm:pb-32" data-id="element-66" data-mp="10jmify08np0r">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-67" data-mp="viylkvpbwdym">
        <Reveal data-id="element-68" data-mp="qjc6shtuqpnp">
          <h2 className="text-center font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-69" data-mp="qjvopyji5e1q">
            Hvad får du med det samme?
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-70" data-mp="1j7hrx5otigo2">
          <ul className="mx-auto mt-12 w-full max-w-[720px] divide-y divide-line rounded-card border border-line bg-white shadow-card" data-id="element-71" data-mp="1j89n4fei6cdt">
            {deliveryItems.map(item => <li key={item} className="flex items-start gap-4 px-6 py-5 sm:px-8" data-id="element-72" data-mp="19h6mtftee1fl">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green" data-id="element-73" data-mp="26xlst5amg2bd">
                  <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-74" data-mp="225u0oqbthoj4" />
                </span>
                <span className="text-base leading-relaxed text-ink" data-id="element-75" data-mp="xwqlq648crec">{item}</span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.12} data-id="element-76" data-mp="o5m38wfcioer">
          <p className="mt-8 text-center font-serif text-lg italic text-muted" data-id="element-77" data-mp="o6e00akois6m">
            Du løber aldrig tør for materiale.
          </p>
        </Reveal>
      </div>
    </section>;
}